// src/services/zoomService.js
export async function fetchVideoSDKToken(sessionName, roleType, userIdentity) {
  // Replace with your actual backend endpoint URL
  const response = await fetch(`${process.env.REACT_APP_API}/api/video/token`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ sessionName, roleType, userIdentity }),
  });
  const data = await response.json();

  if (!data.success) {
    throw new Error("Failed to fetch Video SDK token");
  }
  return data.data;
}

export async function saveVideoSDK(formData) {
  // Replace with your actual backend endpoint URL
  const response = await fetch(`${process.env.REACT_APP_API}/api/video/save`, {
    method: "POST",
    body: formData,
  });

  const data = await response.json();
  // Return the whole data object, which should include a 'success' flag
  return data;
}
